export default __webpack_public_path__ + "static/emma-share-image-b8fe8e3f48769d851a4e35e792d77560.jpg";